import React from "react";
import classnames from "classnames";
import { useStateValue } from "../../context-store/AppStateProvider";
import { Modal } from "@instructure/ui-modal";
import { Spinner } from "@instructure/ui-spinner";
import styles from "./AppSpinner.module.scss";

const IasAppSpinner = ({ show }: { show?: boolean }) => {
  const [{ isAppLoading, isCallingApi }] = useStateValue();

  return (
    <div className={classnames(styles.AppSpinner)}>
      <Modal
        as="aside"
        open={show || isAppLoading || isCallingApi}
        label={isAppLoading ? "Loading app" : isCallingApi ? "Calling api" : ""}
        size="fullscreen"
        className={classnames(styles.AppSpinnerModal)}
        insertAt="top"
      >
        <Modal.Body>
          <div className={classnames(styles.AppSpinnerBody)}>
            <Spinner
              as="div"
              renderTitle="Loading Create Class form"
              size="medium"
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default IasAppSpinner;
